import { api } from './api.util';

export const checkMockTestPurchase = async (mockTestId) => {
  try {
    const response = await api.get(`/purchases/check-mock-test/${mockTestId}`);
    return response;
  } catch (error) {
    console.error('Error checking mock test purchase:', error);
    throw error;
  }
};

export const getMockTestPurchaseInfo = async (mockTestId) => {
  try {
    const response = await api.get(`/purchases/mock-test-info/${mockTestId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting mock test purchase info:', error);
    throw error;
  }
};

export const getMyPurchasedMockTests = async () => {
  try {
    const response = await api.get('/purchases/my-mock-tests');
    return response.data;
  } catch (error) {
    console.error('Error getting purchased mock tests:', error);
    throw error;
  }
};

export const createMockTestPurchaseOrder = async (mockTestId) => {
  try {
    const response = await api.post(`/purchases/create-order-mock-test/${mockTestId}`, {});
    return response;
  } catch (error) {
    console.error('Error creating mock test purchase order:', error);
    throw error;
  }
};

export const purchaseMockTest = async (mockTestId, paymentDetails) => {
  try {
    const response = await api.post(`/purchases/buy-mock-test/${mockTestId}`, {
      razorpay_order_id: paymentDetails.razorpay_order_id,
      razorpay_payment_id: paymentDetails.razorpay_payment_id,
      razorpay_signature: paymentDetails.razorpay_signature
    });
    return response;
  } catch (error) {
    console.error('Error purchasing mock test:', error);
    throw error;
  }
};
